// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes shimmer-loading{0%{background-position:200% 0}100%{background-position:-200% 0}}.trim-symbol{border:1px solid #5a6272;padding-left:2px;padding-right:2px;padding-top:4px;padding-bottom:4px;border-radius:3px;background-color:#f0f0f4;position:relative;top:1px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
